import { TemplatePortal } from '@angular/cdk/portal';

export class EuiMessageBoxConfig implements EuiMessageBoxInterface {
    e2eAttr: string = 'eui-message-box';
    type: ('info' | 'success' | 'warning' | 'danger' | 'question') = 'warning';
    acceptLabel: string = 'eui.YES';
    dismissLabel: string = 'eui.NO';
    hasCloseButton: boolean = true;
    closeOnClickOutside: boolean = false;

    constructor(values: EuiMessageBoxInterface) {
        Object.assign(this, values);
    }
}

export interface EuiMessageBoxInterface {
    e2eAttr?: string;
    title?: string;
    type?: ('info' | 'success' | 'warning' | 'danger' | 'question');
    acceptLabel?: string;
    dismissLabel?: string;
    content?: string | TemplatePortal;
    footer?: TemplatePortal;
    hasCloseButton?: boolean;
    closeOnClickOutside?: boolean;

    outsideClick?: () => void;
    open?: () => void;
    close?: () => void;
    dismiss?: () => void;
    accept?: () => void;
}
